define.alias("shared/components/shared/table-analytics", "media/components/shared/table-analytics");